import $ from "jquery";

function init(): void {
  if ($(".js-load-wistia-video").length) {
    $.getScript("//fast.wistia.com/assets/external/E-v1.js", function () {
      // console.log(data); // Data returned
      // console.log(textStatus); // Success
      // console.log(jqxhr.status); // 200
      // console.log("Load was performed.");
    });
  }
}

export default { init };
